"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWithRequiredUndef = exports.isWithRequired = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
// eslint-disable-next-line
function isWithRequired(whatever, validate) {
    return ((0, echain_shared_ts_utils_1.isDefinedObject)(whatever) &&
        Object.entries(validate).every(([key, validator]) => {
            if (typeof validator === 'function') {
                return validator(whatever[key]);
            }
            return whatever[key] != null;
        }));
}
exports.isWithRequired = isWithRequired;
function isWithRequiredUndef(whatever, validate) {
    return ((0, echain_shared_ts_utils_1.isDefinedObject)(whatever) &&
        Object.entries(validate).every(([key, validator]) => {
            if (typeof validator === 'function') {
                return validator(whatever[key]);
            }
            // required
            if (validator === true) {
                return whatever[key] != null;
            }
            // omit
            return whatever[key] == null;
        }));
}
exports.isWithRequiredUndef = isWithRequiredUndef;
//# sourceMappingURL=WithRequired.js.map